import { gql } from '@apollo/client';
export const documentHtmlData = gql `
  query DownloadDocumentHtmlDataForPDFGeneration($documentId: ID!, $companyId: UUID!) {
    fileSystemDocument(id: $documentId) {
      id
      strippedHtmlBody
    }

    company: company2(id: $companyId) {
      id
      logoPath
      logoUploaded
    }
  }
`;
